import { Authority } from 'platform/app/authority.constant';

export const WEBSITES = {
    name: 'Websites',
    path: '/admin-panel/websites',
    requiresAuthority: Authority.ROLE_ADMIN_PANEL_VIEW_EDIT,
};
